import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-0"}],["path",{"d":"M17 13v-5l4 8v-8","key":"svg-1"}],["path",{"d":"M14 14a2 2 0 1 1 -4 0v-4m2 -2a2 2 0 0 1 2 2","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconHttpConnectOff = createReactComponent('outline', 'http-connect-off', 'HttpConnectOff', __iconNode);

export default IconHttpConnectOff;